export default __webpack_public_path__ + "static/SR China - Kosher - Certificate-d32e808da59c85184f34f4ef2ec6dae0.pdf";